import { type DashboardCardKey, DASHBOARD_CARD_KEYS } from "../../features/dashboard/preferences/constants";


export interface DashboardMenuGroup {
  id: string;
  label: string;
  childKeys: DashboardCardKey[];
}

export const DASHBOARD_MENU_GROUPS: DashboardMenuGroup[] = [
  {
    id: 'financial-stats',
    label: 'financial-stats',
    childKeys: [
      DASHBOARD_CARD_KEYS.financialRevenue,
      DASHBOARD_CARD_KEYS.financialExpenses,
      DASHBOARD_CARD_KEYS.financialNetProfit,
      DASHBOARD_CARD_KEYS.financialOutstanding,
      DASHBOARD_CARD_KEYS.financialGreenBean,
      DASHBOARD_CARD_KEYS.financialRoasted,
      DASHBOARD_CARD_KEYS.financialFinished,
    ],
  },
  {
    id: 'green-bean-profile',
    label: 'green-bean-profile',
    childKeys: [DASHBOARD_CARD_KEYS.greenBeanSpecies, DASHBOARD_CARD_KEYS.greenBeanVarietals],
  },
];

export const DASHBOARD_MENU_SINGLE_ITEMS: Array<{ key: DashboardCardKey; label: string }> = [
  { key: DASHBOARD_CARD_KEYS.activityFeed, label: 'activity_feed' },
  { key: DASHBOARD_CARD_KEYS.inventoryExpiringSoon, label: 'inventory_expiring_soon' },
  { key: DASHBOARD_CARD_KEYS.inventoryLowStock, label: 'inventory_low_stock' },
  { key: DASHBOARD_CARD_KEYS.averageShrinkage, label: 'average_shrinkage' },
  { key: DASHBOARD_CARD_KEYS.quickActions, label: 'quick_actions' },
];

export const DASHBOARD_MENU_ITEM_LABELS: Partial<Record<DashboardCardKey, string>> = {
  [DASHBOARD_CARD_KEYS.financialRevenue]: 'financial_revenue',
  [DASHBOARD_CARD_KEYS.financialExpenses]: 'financial_expenses',
  [DASHBOARD_CARD_KEYS.financialNetProfit]: 'financial_net_profit',
  [DASHBOARD_CARD_KEYS.financialOutstanding]: 'financial_outstanding',
  [DASHBOARD_CARD_KEYS.financialGreenBean]: 'financial_green_bean',
  [DASHBOARD_CARD_KEYS.financialRoasted]: 'financial_roasted',
  [DASHBOARD_CARD_KEYS.financialFinished]: 'financial_finished',
  [DASHBOARD_CARD_KEYS.greenBeanSpecies]: 'green_bean_species',
  [DASHBOARD_CARD_KEYS.greenBeanVarietals]: 'green_bean_varietals',
};
